module.exports = __webpack_public_path__ + "a2c849d1e1ca7a383bb5b81dad1d4cac.svg";